import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1848">
      <div className="dark" data-id="element-1849">
        <Hero data-id="element-1850" />
      </div>
      <WhyUs data-id="element-1851" />
      <Services data-id="element-1852" />
      <HowItWorks data-id="element-1853" />
      <FAQ data-id="element-1854" />
      <Reviews data-id="element-1855" />
      <CtaBanner data-id="element-1856" />
    </main>;
}